import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {createLogger} from "./app/shared/helpers/logger/logger";

const logger = createLogger('bootstrapApplication');

// Function to add target="_blank" and rel="noopener noreferrer" to all external links
function updateExternalLinks(): void {
    const currentHost = window.location.hostname;

    // Use MutationObserver to dynamically monitor changes
    const observer = new MutationObserver(() => {
        const links = document.querySelectorAll('a[href]') as NodeListOf<HTMLAnchorElement>;

        links.forEach(link => {
            const linkHost = new URL(link.href).hostname;

            if (linkHost && linkHost !== currentHost) {
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
            }
        });
    });

    // Observe changes in the body
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        updateExternalLinks();
    })
    .catch((err) => logger.error(err));
